import React from "react";

const SwitcherMapMode = ({ type, text, img, isActive, onClick = () => { } }: IProps) => {

    const info = {
        roadMaps: 'Маршруты',
        busStops: 'Остановки'
    }

    return (
        <div className="map-screen__switcher-map-mode" data-tooltip-id="my-tooltip" data-tooltip-content={info[type]}>
            {/* <span className="map-screen__switcher-map-mode__text">{text}</span> */}
            <button
                onClick={onClick}
                className={
                    `map-screen__switcher-map-mode__button green-shadow
                    ${isActive ? 'map-screen__switcher-map-mode__button_active' : ''}`
                }>
                <img src={img} alt={text} className="map-screen__switcher-map-mode__img" />
            </button >
            {/* <span className="map-screen__switcher-map-mode__text">{text}</span> */}
        </div >
    )
}

export default SwitcherMapMode;

interface IProps {
    type: 'roadMaps' | 'busStops',
    text?: string,
    img: any,
    isActive?: boolean,
    onClick?: () => void
}